var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentUser)?_c('div',{staticClass:"header-nav"},[(_vm.admin)?_c('admin-nav'):_vm._e(),_vm._v(" "),(_vm.support)?_c('support-nav'):_vm._e(),_vm._v(" "),(_vm.currentUser.id)?_c('current-user-nav'):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52b4d3ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderNav.vue
// module id = 1192
// module chunks = 1